module.exports = __webpack_public_path__ + "img/icon-airoute.a51fbd21.svg";